<template>
    <j-modal
      :width="showCode ? 1200 : 500"
      :visible="visible"
      :closable="false"
      :maskClosable="false"
      :destroyOnClose="true"
      :title="null"
      fullscreen
      @cancel="handleCancel"
      cancelText="关闭"
    >
      <template slot="footer">
        <a v-if="!showCode" target="_blank" :href="getEditorUrl(workInfo)">查看代码</a>
        <a-divider type="vertical"></a-divider>
        <a-button type="default" @click="handleCancel">关闭</a-button>
      </template>
      <div>
        <iframe
          :src="showCode ? getEditorUrl(workInfo) : getPlayerUrl(workInfo)"
          :style="{ height: showCode ? '800px' : '400px' }"
          id="player"
          frameborder="0"
          width="100%"
          :scrolling="workInfo.codeType <= 2 ? 'no' : ''"
        ></iframe>
      </div>
    </j-modal>
  </template>
  
  <script>
  import { defaults } from 'codemirror'
  export default {
    name: 'TeachingWorkPreviewModal',
    components: {},
    props: {
      showCode: {
        //默认显示代码
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        workId: '',
        workInfo: {},
        width: 500,
        visible: false,
      }
    },
    created() {
      var that = this
      //scratch全屏
      document.addEventListener('scratchFullScreen', function (e) {
        that.launchIntoFullscreen(document.getElementById('player'))
      })
      //scratch退出全屏
      document.addEventListener('scratchUnFullScreen', function (e) {
        that.exitFullscreen()
      })
      //scratch获取焦点
      document.addEventListener('scratchInit', function (e) {
        var p = document.getElementById('player')
        var s = p.contentDocument.getElementById('scratch')
        s.addEventListener('click', () => {
          p.focus()
        })
      })
    },
    methods: {
      view(record) {
        this.visible = true
        this.workInfo = record
      },
      viewById(id, codeType) {
        this.visible = true
        this.workInfo = { id, codeType }
      },
      viewByUrl(workUrl, codeType) {
        this.visible = true
        if(!codeType){
          codeType = this.getCodeTypeByName(workUrl)
        }
        this.workInfo = { workUrl, codeType }
      },
      getCodeTypeByName(workUrl) {
        console.log(workUrl);
        let s = workUrl.split('.')
        let suffix = s[s.length - 1]
        switch (suffix) {
          case 'sb2':
            return 1
          case 'sb3':
            return 2
          case 'sjr':
            return 3
          case 'py':
            return 5 //这里区分不出是turtle还是python
          case 'c':
            return 6
          case 'cpp':
            return 7
          case 'java':
            return 8
          default:
            return 0
        }
      },
      getPlayerUrl() {
        let url
        switch (this.workInfo.codeType) {
          case 1:
            url = '/scratch3/player.html?'
            break
          case 2:
            url = '/scratch3/player.html?'
            break
          case 3:
            url = '/scratchjr/editor.html?mode=edit&'
            break
          case 4:
            url = '/onlinecode/player.html?lang=turtle&'
            break
          case 5:
            url = '/onlinecode/player.html?lang=python&'
            break
          case 6:
            url = '/onlinecode/player.html?lang=c&'
            break
          case 7:
            url = '/onlinecode/player.html?lang=cpp&'
            break
          case 8:
            url = '/onlinecode/player.html?lang=java&'
          case 10:
            url = '/blockly/index.html?lang=zh-hans&'
            break
          default:
            url = this.workInfo.workUrl
        }
        if (url && this.workInfo.id) {
          url += 'workId=' + this.workInfo.id
        } else if (url && this.workInfo.workUrl) {
          url += 'workUrl=' + this.workInfo.workUrl
        }
        return url
      },
      getEditorUrl() {
        let url
        switch (this.workInfo.codeType) {
          case 1:
            url = '/scratch3/index.html?scene=review&'
            break
          case 2:
            url = '/scratch3/index.html?scene=review&'
            break
          case 3:
            url = '/scratchjr/editor.html?mode=edit&'
            break
          case 4:
            url = '/onlinecode/index.html?lang=turtle&'
            break
          case 5:
            url = '/onlinecode/index.html?lang=python&'
            break
          case 6:
            url = '/onlinecode/index.html?lang=c&'
            break
          case 7:
            url = '/onlinecode/index.html?lang=cpp&'
            break
          case 8:
            url = '/onlinecode/index.html?lang=java&'
            break
          case 10:
            url = '/blockly/index.html?lang=zh-hans&'
            break
          default:
             url = this.workInfo.workUrl
        }
        if (url && this.workInfo.id) {
          url += 'workId=' + this.workInfo.id
        } else if (url && this.workInfo.workUrl) {
          url += 'workUrl=' + this.workInfo.workUrl
        }
  
        return url
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleCancel() {
        this.close()
      },
      launchIntoFullscreen(element) {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      },
      exitFullscreen() {
        if (window.document.exitFullscreen) {
          window.document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          window.document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) {
          window.document.webkitExitFullscreen()
        }
      },
    },
  }
  </script>
  
  <style lang="less" scoped>
  iframe {
    display: block;
    margin: auto;
  }
  .ant-modal {
    top:10px;
  }
  </style>